'use client';
import { Button } from '@vs-shop/ui/button';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

import { lastPageLoadedIncludingLoadMoreAtom } from '@vs-shop/engine/atom/brand/pagination';
import type { HydraViewExtended } from '@vs-shop/schemas/openapi/hydraView';
import { useAtomValue } from '@effect/atom-react';

type Props = {
  hydraViewExtended: HydraViewExtended;
  loadMorePages: (fn: (val: number) => number) => void;
  isLoading?: boolean;
};

export default function BrandsLoadNextPage({ hydraViewExtended, loadMorePages, isLoading }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();
  const lastPageLoadedIncludingLoadMore = useAtomValue(lastPageLoadedIncludingLoadMoreAtom);

  // Hide button if we're at the last page
  if (lastPageLoadedIncludingLoadMore === hydraViewExtended.hydraViewNumbers.last) {
    return null;
  }

  const handleLoadMore = () => {
    loadMorePages((val) => val + 1);
  };

  return (
    <div data-slot="brands-load-more-wrapper" className="mt-8 flex w-full justify-center uppercase">
      <Button
        className="uppercase"
        onClick={handleLoadMore}
        loading={isLoading}
        disabled={isLoading}
        data-slot="brands-load-more"
        aria-busy={isLoading ? true : undefined}
      >
        {intl.formatMessage({
          id: 'component.client.page.brands.brandsLoadNextPage.showMore',
          defaultMessage: 'ZOBRAZIT DALŠÍ',
        })}
      </Button>
    </div>
  );
}
